<script setup lang="ts">
import { computed } from 'vue'
import CollapsibleCard from './CollapsibleCard.vue'

// One collapsed row for the synth-NAV diagnostics (Momentum gate, VIX regime,
// NAV source) that do not drive the decision under the futures rule. Kept one
// click away — Plans 2–3 (synth_nav_0740) still need them — without letting
// them compete with the decision story.
const props = defineProps<{ items: string[] }>()
const summary = computed(() => props.items.join(' · '))
</script>

<template>
  <CollapsibleCard v-if="items.length" title="Not used by the current rule" testid="retired-diagnostics" :summary="summary">
    <div class="retired-grid"><slot /></div>
  </CollapsibleCard>
</template>

<style scoped>
.retired-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 8px; opacity: .75; }
</style>
